module.exports = `<!DOCTYPE html>

<html>
<head><meta http-equiv=Content-Type content="text/html; charset=UTF-8">
<style type="text/css">
</style>
</head>
<body>
<div style="">
<div style="top: 0px;margin-top: 10px; padding-bottom: 10px;text-align: justify; font-family: Quicksand;">
<p align="center">
    <strong>Términos y Condiciones </strong>
</p>
<p >
    Estimado Visitante y Usuario le pedimos leer cuidadosamente los siguientes
Términos y Condiciones que rigen la navegación, acceso y uso de    <strong>govo.legal </strong>a través del sitio web
    <a href="http://www.govo.legal/" target="_blank">
        <strong>www.govo.legal</strong>
    </a>
    <strong> </strong>
    así como los servicios que se prestan en dicho sitio.
    <br/>
</p>
<p>
    <p>
    </p>
    Le recordamos que al navegar en el sitio web
    <a href="http://www.govo.legal/" target="_blank">
        <strong>www.govo.legal</strong>
    </a>
e ingresar, registrarse y/o utilizar    <strong>govo.legal </strong>acepta obligarse sin ningún tipo de
    reserva a los presentes Términos y Condiciones.
</p>
<p>
    <strong>1. </strong>
    <strong>IDENTIFICACIÓN DEL PROVEEDOR</strong>
</p>
<p>
    <strong></strong>
    1.1. <strong>govo.legal</strong> es un producto de A3 Cloud
    Microservices S.A.P.I. de C.V (en adelante “<strong>A3</strong>”) así como
    todos y cada uno de los sistemas informáticos, componentes, aplicaciones,
    herramientas, métodos, relacionados y disponibles en
    <a href="http://www.govo.legal/" target="_blank">
        <strong>www.govo.legal</strong>
    </a>
    <strong> </strong>
    para prestar los servicios contemplados en los presentes Términos y
    Condiciones, salvo aquellos en que expresamente se señale se encuentran
    proveídos por terceros.
</p>
<p>
    <p>
    </p>
    1.2. Si tiene alguna duda, comentario o sugerencia sobre estos Términos y
    Condiciones, le proporcionamos la información de contacto:
</p>
<p>
    <p>
    </p>
    a) Nombre comercial: <strong>govo.legal</strong>
</p>
<p>
    c) Denominación o razón social: A3 Cloud Microservices, S.A.P.I. de C.V.
</p>
<p>
    d) Domicilio físico en territorio nacional: Ignacio Allende 888, Col.
    Centro, Monterrey, Nuevo León, C.P. 64000
</p>
<p>
    e) Registro Federal de Contribuyentes: ACM180426PB4
</p>
<p>
    f) Medio de contacto: <a name="_Hlk62831916"></a>
    <a href="mailto:contacto@govo.legal">
        contacto@govo.legal
    </a>
</p>
<p>
    g) Página web:<strong> www.govo.legal</strong>
</p>
<p>
    <strong>2. </strong>
    <strong>DEFINICIONES</strong>
</p>
<p>
    <strong>govo.legal: </strong>
    se refiere al software por medio del cual se ofrece una serie de
    herramientas de gestión para firmar Documentos electrónicos mediante Firma
    electrónica o Firma electrónica avanzada o fiable;
</p>
<p>
    <strong>Autoridad certificadora: </strong>
    las dependencias y entidades de la Administración Pública Federal y los
    prestadores de servicios de certificación que, conforme a las disposiciones
    jurídicas, tengan reconocida esta calidad y cuenten con la infraestructura
    tecnológica para la emisión, administración y registro de certificados
    digitales, así como para proporcionar servicios relacionados con los
    mismos;
</p>
<p>
    <strong>Certificado digital: </strong>
    el mensaje de datos o registro que confirma el vínculo entre un firmante y
    la clave privada;
</p>
<p>
    <strong>Clave privada:</strong>
    los datos que el firmante genera de manera secreta y utiliza para crear su
    firma electrónica avanzada, a fin de lograr el vínculo entre dicha firma
    electrónica avanzada y el firmante;
</p>
<p>
    <strong>Cliente: </strong>
la persona física o moral, que por su cuenta contrata con<strong>A3</strong> un Plan y/o servicios adicionales que se ofrecen en<strong>govo.legal</strong> disponibles en el sitio web    <a href="http://www.govo.legal/" target="_blank">www.govo.legal</a>;
</p>
<p>
    <strong>Firma electrónica: </strong>
    son los datos en forma electrónica consignados en un Mensaje de Datos, o
    adjuntados o lógicamente asociados al mismo por cualquier tecnología, que
    son utilizados para identificar al firmante en relación con el Mensaje de
    Datos e indicar que el firmante aprueba la información contenida en el
    Mensaje de Datos, y que produce los mismos efectos jurídicos que la firma
    autógrafa, siendo admisible como prueba en juicio;
    <br/>
</p>
<p>
    <strong>Firma electrónica avanzada o fiable</strong>
    : aquella Firma electrónica que ha sido creada con datos que corresponden
    exclusivamente al firmante, se encuentra bajo su control exclusivo, y que
    permite detectar cualquier alteración de la firma o alteración de la
    información que se firma;
</p>
<p>
    <strong>Invitado:</strong>
    es la persona física que, con motivo de la solicitud y bajo la
responsabilidad de un Cliente, lleva a cabo su registro en<strong>govo.legal</strong> a través del sitio web    <a href="http://www.govo.legal/" target="_blank">www.govo.legal</a> para
    firmar, mediante el uso de medios electrónicos, Documentos electrónicos
    proporcionado por dicho Cliente;
    <br/>
</p>
<p>
    <strong>Mensaje de datos o Documento electrónico</strong>
    : la información generada, enviada, recibida o archivada por medios
    electrónicos, ópticos o cualquier otra tecnología;
    <br/>
</p>
<p>
    <strong></strong>
</p>
<p>
    <strong>Plan: </strong>
establece los servicios que se prestarán a través de    <strong>govo.legal</strong>, así como sus alcances,
restricciones y costos, que se encuentran publicados en la siguiente liga:<a href="http://www.govo.legal/" target="_blank">www.govo.legal</a>    <strong></strong>
</p>
<p>
    <strong>Prestadores de Servicios de Certificación</strong>
    : es la persona o institución pública que presta servicios relacionados con
    firmas electrónicas, expide los certificados o presta servicios
    relacionados como la conservación de mensajes de datos, el sellado digital
    de tiempo y la digitalización de documentos impresos, en los términos que
    se establezca en la norma oficial mexicana sobre digitalización y
    conservación de mensajes de datos que para tal efecto emita la Secretaría
    de Economía;
    <br/>
</p>
<p>
    <strong>Usuario: </strong>
cualquier Invitado, Cliente y/o Usuario Autorizado que usa    <strong>govo.legal</strong>;
    <br/>
</p>
<p>
    <strong>Usuario autorizado:</strong>
    es la persona física, ya sea un empleado, socio comercial o agente, que
    está registrado o autorizado por el Cliente para usar el Plan contratado
con <strong>A3</strong> en relación con los servicios de    <strong>govo.legal</strong>, y
    <br/>
</p>
<p>
    <strong>Visitante</strong>
: es la persona física que navega en el sitio web    <a href="http://www.govo.legal/" target="_blank" target="_blank">www.govo.legal</a>, sin
    contar con un registro, cuenta o usuario.
    <br/>
</p>
<p>
    <strong>3. </strong>
    <strong>ACEPTACIÓN DEL USO DE </strong>
    <strong>govo.legal</strong>
</p>
<p>
    3.1. Al utilizar el sitio web
    <a href="http://www.govo.legal/" target="_blank">
        <strong>www.govo.legal</strong>
    </a>
    <strong> </strong>
    así como<strong> </strong><strong>govo.legal</strong> o
    cualquiera de los servicios que se prestan a través de dicho sitio, usted
    como Usuario acepta estar obligado y cumplir con estos Términos y
    Condiciones, ya sea a nombre propio o de la entidad que legalmente
    represente.
</p>
<p>
    3.2. Por tanto, al aceptar los presentes Términos y Condiciones, el Usuario
celebra un acuerdo sobre el uso de la plataforma    <strong>govo.legal</strong>, y estos le serán de observancia
obligatoria actualizándose sus derechos y obligaciones frente a    <strong>A3</strong>.
</p>
<p>
    3.3. El Usuario declara bajo protesta de decir verdad que:
</p>
<p>
    a) Es mayor de edad;
</p>
<p>
    b) Cuenta con la capacidad legal y se encuentra en pleno goce del ejercicio
    de sus facultades para aceptar los presentes Términos y Condiciones a
    nombre propio, y en su caso, cuenta con las autorizaciones y poderes
    necesarios para hacerlo a nombre de la persona moral que legalmente
    representa;
</p>
<p>
    c) Los Términos y Condiciones son claros y los ha comprendido plenamente en
    cuanto a su contenido, objeto, alcance comercial y legal;
</p>
<p>
d) Los datos personales proporcionados para su registro y acceso en    <strong>govo.legal </strong>como método de identificación, son
    propios, auténticos y verificables;
</p>
<p>
    e) Recibió toda la información necesaria para comprender los servicios que
se prestan a través de <strong>govo.legal</strong>,    <strong> </strong>así como su funcionamiento;
</p>
<p>
f) Reconoce y acepta que los servicios prestados a través de    <strong>govo.legal </strong>se rigen por lo dispuesto en los
    presentes Términos y Condiciones, el Aviso de Privacidad disponible en el
    sitio
    <a href="http://www.govo.legal/" target="_blank">
        <strong>www.govo.legal</strong>
    </a>
    , así como los alcances de los Planes contratados, y
</p>
<p>
    g) Observará las disposiciones legales que le resulten aplicables.
</p>
<p>
    3.4. Si no está de acuerdo con el contenido y alcance de los presentes
    Términos y Condiciones no estará autorizado para usar el sitio
    <a href="http://www.govo.legal/" target="_blank">
        <strong>www.govo.legal</strong>
    </a>
    ni <strong>govo.legal</strong>, por lo que deberá abstenerse de
    registrarse y dejar de utilizar el sitio mencionado y cualquier servicio
    que se preste a través de este.
</p>
<p>
    <strong>4. </strong>
    <strong>
        CARACTERÍSTICAS DEL SERVICIO Y PROCEDIMIENTOS DE USO DE govo.legal
    </strong>
</p>
<p>
    4.1. Los servicios prestados en el sitio
    <a href="http://www.govo.legal/" target="_blank">
        <strong>www.govo.legal</strong>
    </a>
    <strong> </strong>
    pueden ser utilizados solamente con posterioridad a su contratación,
    activación, registro y previo pago de estos.
</p>
<p>
4.2. Los servicios que se ofrecen en    <strong>govo.legal </strong>a través del sitio web
    <a href="http://www.govo.legal/" target="_blank">
        <strong>www.govo.legal</strong>
    </a>
    se proporcionarán de acuerdo con el Plan que cada Cliente haya contratado,
    estos Términos y Condiciones y el Aviso de Privacidad publicado en el sitio
    mencionado.
</p>
<p>
4.3. La contratación de los Planes que se formalicen a través de    <strong>govo.legal</strong> así como cualquier otro mecanismo de
    comunicación establecido y acordado con los Clientes, goza de todos los
    efectos jurídicos a que haya lugar conforme a las disposiciones legales
    aplicables, y en particular conforme a lo dispuesto en el Título Segundo De
    Comercio Electrónico del Código de Comercio.
</p>
<p>
    4.4. Los Usuarios de <strong>govo.legal</strong> podrán contar
    con asistencia para auxiliarlos en el registro, ingreso, acceso, consulta,
    así como en la ejecución de las funcionalidades descritas en los presentes
    Términos y Condiciones para lo cual deberán enviar correo electrónico a la
    siguiente dirección
    <a href="mailto:contacto@govo.legal">
        contacto@govo.legal
    </a>
    .
</p>
<p>
    4.5. Los servicios que se ofrecen en <strong>govo.legal</strong>
    a través del sitio web
    <a href="http://www.govo.legal/" target="_blank">
        <strong>www.govo.legal</strong>
    </a>
    <strong> </strong>
    consisten en proveer funcionalidades para que los Usuarios manifiesten su
    voluntad sobre cualquier acuerdo, convenio, contrato, o acto jurídico que
    deseen suscribir utilizando, bajo su absoluta responsabilidad, alguno de
    los métodos disponibles en <strong>govo.legal </strong>para
identificarse,<strong> </strong>verificar dicha identidad,    <strong> </strong>para crear<strong> </strong>una Firma electrónica o una
Firma electrónica avanzada o fiable y<strong> </strong>en su caso    <strong> </strong>verificar dichas firmas, lo anterior conforme a lo
    dispuesto en el Código de Comercio, Ley de Firma Electrónica Avanzada y
    demás disposiciones legales aplicables.
</p>
<p>
    4.6. En virtud de lo anterior, el Usuario acepta y reconoce que al decidir
firmar un Mensaje de datos y/o un Documento electrónico a través de    <strong>govo.legal</strong>, lo hace bajo su absoluta
    responsabilidad y en consecuencia comprende que de conformidad con lo
    dispuesto en los artículos 89 del Código de Comercio y 2, fracción XIII, de
    la Ley de Firma Electrónica Avanzada produce los mismos efectos jurídicos
    que la firma autógrafa, siendo admisible como prueba en juicio.
</p>
<p>
    <a name="_Hlk63085874">
        4.7. Para tales efectos<strong> govo.legal </strong>
        contempla, entre otras, las siguientes funcionalidades:
    </a>
</p>
<p>
a) Visualizar Planes sobre la prestación de servicios contemplados en    <strong>govo.legal</strong>;
</p>
<p>
b) Registrarse como Invitado, Cliente o Usuario Autorizado de    <strong>govo.legal</strong>, según corresponda;
</p>
<p>
c) Contratar Planes sobre la prestación de servicios contemplados en    <strong>govo.legal</strong>;
</p>
<p>
    d) Visualizar y aceptar los presentes Términos y Condiciones;
</p>
<p>
    e) Aceptar la transacción comercial mediante la cual contrata los
    servicios;
</p>
<p>
    f) Recibir el comprobante fiscal correspondiente por el pago del servicio
    prestado;
</p>
<p>
    g) Iniciar, modificar y cancelar solicitudes de firmado de documentos en
medios electrónicos conforme a las funcionalidades de    <strong>govo.legal </strong>contenidas en el sitio
    <a href="http://www.govo.legal/" target="_blank">
        <strong>www.govo.legal</strong>
    </a>
    ;
</p>
<p>
    h) Enviar, publicar, cargar, poner a disposición o visualizar contenido
    para Invitados y/o Clientes;
</p>
<p>
    i) Firmar Documentos electrónicos mediante Firma electrónica o Firma
    electrónica avanzada o fiable;
</p>
<p>
j) Recibir y descargar los Documentos electrónicos firmados en    <strong>govo.legal</strong>;
</p>
<p>
k) Recibir notificaciones vía correo electrónico sobre los servicios de    <strong>govo.legal</strong>, y
</p>
<p>
    l) Conocer la situación en la que se encuentran las solicitudes de firmado
    de documentos en medios electrónicos.
</p>
<p>
    4.8. Cuando el Usuario elija el uso de la Firma electrónica avanzada basada
    en Certificados digitales emitidos por Autoridad certificadora reconocida
    conforme a las disposiciones legales mexicanas, el Usuario mantendrá la
    secrecía, confidencialidad, posesión e integridad de la Clave privada, así
    como de su contraseña, en virtud de que la misma se encuentra en su control
    exclusivo y es el único que debe y puede firmar los Mensajes de datos y/o
    Documentos electrónicos.
</p>
<p>
    4.9. En virtud de lo anterior, el Usuario no debe en ninguna circunstancia,
    entregar su Certificado digital ya que es responsable y único obligado de
    su custodia, así como de su Clave privada vinculada a dicho Certificado. El
    Usuario entiende que <strong>A3</strong> en ningún momento almacenará ni
    conservará de ningún modo el Certificado digital, Clave privada o
    contraseña del Usuario.
</p>
<p>
    4.10. Adicionalmente <strong>A3</strong> llevará a cabo la verificación y
    autentificación de los Certificados digitales directamente con las
    Autoridades certificadoras correspondientes, mediante los servicios de
    consulta que dichas autoridades pongan a disposición para la verificación
    de la validez de los Certificados.
</p>
<p>
    4.11. Para efecto de lo señalado en los presentes Términos y Condiciones se
    le informa al Usuario que conforme a lo dispuesto en el artículo 99 del
    Código de Comercio, como firmante deberá:
</p>
<p>
    a) Cumplir las obligaciones derivadas del uso de la Firma electrónica;
</p>
<p>
    b) Actuar con diligencia y establecer los medios razonables para evitar la
    utilización no autorizada de la misma;
</p>
<p>
    c) Cuando se emplee un Certificado digital en relación con una Firma
    electrónica, actuar con diligencia razonable para cerciorarse de que todas
    las declaraciones que haya hecho en relación con el Certificado, con su
    vigencia, o que hayan sido consignadas en el mismo, son exactas;
</p>
<p>
    d) Responsabilizarse de las consecuencias jurídicas que deriven por no
    cumplir oportunamente las obligaciones previstas en el presente artículo, y
</p>
<p>
    e) Responderá por las obligaciones derivadas del uso no autorizado de su
    Firma, cuando no hubiere obrado con la debida diligencia para impedir su
    utilización.
</p>
<p>
    4.12. El Usuario es responsable de seguir las instrucciones
    correspondientes de conformidad con las funcionalidades que se ponen a su
    disposición a través de <strong>govo.legal </strong>para llevar
    a cabo la Firma electrónica o Firma electrónica avanzada o fiable.
</p>
<p>
4.13. Una vez concluido el proceso de firmado en    <strong> govo.legal</strong> el Usuario recibirá vía correo
    electrónico los Documentos electrónicos firmados para su descarga y
    conservación. Y en caso de haberlo solicitado, adicionalmente recibirá la
    constancia de conservación de mensajes de datos correspondiente emitida por
    el Prestador de Servicios de Certificación.
</p>
<p>
    4.14. Los Documentos electrónicos firmados serán eliminados de manera
    definitiva de <strong>govo.legal</strong>, una vez que dichos
    documentos hayan sido enviados a los Usuarios,<strong> </strong>por lo que
    estos no podrán recuperarse de ninguna manera.
</p>
<p>
    4.15. El Usuario acepta y reconoce que es su exclusiva responsabilidad la
    conservación y resguardo de los Documentos electrónicos firmados, incluso
    en virtud de cualquier obligación que derive de una disposición legal.
</p>
<p>
    4.16. El Usuario podrá, bajo su responsabilidad y completa libertad,
    solicitar la inclusión de servicios adicionales al proceso de firma, tales
    como la emisión de sellos digitales de tiempo y/o constancias de
    conservación de mensajes de datos conforme a la Norma Oficial Mexicana
    NOM-151-SCFI-2016,<em> </em>denominada
    <em>
        “Requisitos que deben observarse para la conservación de mensajes de
        datos y digitalización de documentos”,
    </em>
    dichos servicios se proporcionarán<em> </em>por el Prestador de Servicios
    Certificación que se encuentre debidamente acreditado por la Secretaría de
    Economía y con quien <strong>A3</strong> haya establecido una relación
    comercial. Los servicios mencionados estarán sujetos a los costos
    contemplados en los Planes contratados y les aplicará lo establecido en los
    presentes Términos y Condiciones.
</p>
<p>
    4.17. <strong>govo.legal</strong> incluye mecanismos adecuados
    para mantener la seguridad, protección, eliminación y respaldo de los datos
    de registro de los Usuarios, los cuales contemplan el control en la
    administración de los accesos y las credenciales, el control de los datos
    que serán utilizados para generar la Firma electrónica y la Firma
    electrónica avanzada o fiable y el control de la eliminación de los
    Documentos electrónicos firmados.
</p>
<p>
    4.18. El uso de <strong>govo.legal </strong>que se otorga a los
    Usuarios es personal, intransferible y únicamente para los fines permitidos
    en los presentes Términos y Condiciones, el alcance establecido en el Plan
    contratado, así como lo contemplado en el Aviso de Privacidad disponible en
    el sitio
    <a href="http://www.govo.legal/" target="_blank">
        <strong>www.govo.legal</strong>
    </a>
    .
</p>
<p>
    4.19. Los datos, información y Documentos electrónicos firmados se
    encuentran protegidos por Ley Federal de Protección de Datos Personales en
    Posesión de Particulares, así como las disposiciones legales aplicables
    conforme a los alcances contemplados en el Aviso de Privacidad disponible
    en el sitio
    <a href="http://www.govo.legal/" target="_blank">
        <strong>www.govo.legal</strong>
    </a>
    .
</p>
<p>
    4.20. El Usuario será identificado por una dirección de correo electrónico
    única, en el entendido que dos o más personas no pueden usar los servicios
    de<strong> govo.legal</strong> con el mismo correo electrónico.
</p>
<p>
    4.21. Al momento de ingresar en <strong>govo.legal</strong>, el
    Usuario se autenticará mediante correo electrónico y contraseña.
</p>
<p>
    <strong>5. </strong>
    <strong>MÉCANISMO DE PAGO</strong>
</p>
<p>
    5.1. Al usar <strong>govo.legal</strong> el Cliente acepta pagar
    a <strong>A3</strong> el monto total acordado y cualquier gasto asociado
    por el procesamiento del pago.
</p>
<p>
5.2. Las tarifas y precios de los servicios de    <strong> govo.legal</strong> dependen del Plan seleccionado y
    cualquier otro cargo o servicio adicional solicitado o incurrido por el
    Cliente.
</p>
<p>
    5.3. <strong>A3</strong> se reserva el derecho de hacer propuestas de
    servicio individuales de acuerdo con las necesidades, frecuencia y
    volumetría de uso que requieran los Clientes. Las cuales quedarán sujetas a
    lo dispuesto en los presentes Términos y Condiciones, o en su caso a las
    modificaciones que se acuerden de manera particular con dichos Clientes.
</p>
<p>
    5.4. El pago por los servicios contratados será procesado conforme a la
    forma establecida en el Plan seleccionado por el Cliente, pero en todo
    caso, se cobrará por adelantado y mediante el mecanismo de cobro acordado
    con el Cliente. Por lo que el Cliente autoriza a <strong>A3</strong> a
    realizar los cobros en la forma en que se haya acordado, incluyendo cargos
    recurrentes de manera mensual, trimestral o anual, según se haya acordado
    con el Cliente.
</p>
<p>
    5.5. Los servicios de <strong>govo.legal</strong> se activarán
    una vez que se realice el pago de estos de acuerdo con la forma y modo de
pago pactado con el Cliente. En caso de que el Cliente no realice el pago,    <strong>A3 </strong>no se encontrará obligada a la prestación del servicio.
</p>
<p>
    5.6. Los cargos se facturarán después de que se haya realizado el pago de
    los servicios y se entregará al Cliente la factura una vez activado el Plan
    contratado.
</p>
<p>
    5.7. El Cliente deberá notificar al correo electrónico
    <a href="mailto:contacto@govo.legal">
        contacto@govo.legal
    </a>
    cualquier cambio en la información fiscal para la emisión de la factura.
</p>
<p>
    5.8. El Cliente se responsabiliza de buena fe a mantener la disponibilidad
    de pago, a través de los medios declarados durante su proceso de
    contratación, por lo que conoce y acepta que deberá tener los fondos
    suficientes para cubrir los servicios señalados.
</p>
<p>
    5.9. Los pagos realizados por el Cliente no son reembolsables, excepto por
    lo expresamente contemplado en los presentes Términos y Condiciones.
</p>
<p>
    5.10. Cualquier cantidad que no sea pagada, a su vencimiento, estará sujeta
    a cargos financieros equivalentes al 3% del saldo no pagado, por cada mes.
    Este monto será determinado e incrementado diariamente, desde la fecha de
    vencimiento, hasta la fecha en que se cubra el pago pendiente.
</p>
<p>
    5.11. El Cliente reembolsará a <strong>A3</strong> los costos o gastos
    incurridos por <strong>A3</strong> para cobrar o recuperar cualquier monto
    que no se haya pagado a su vencimiento.
</p>
<p>
    5.12. Los Planes contratados no se renuevan automáticamente, por lo que el
    Usuario entiende que es su absoluta responsabilidad la continuidad del
    servicio que se presta a través de <strong>govo.legal</strong>.
    En su caso, acepta pagar el costo vigente al momento de la renovación
    asociado con el Plan contratado.
</p>
<p>
    5.13. Si <strong>A3</strong> no recibe el pago correspondiente del Plan
    seleccionado por el Cliente, el Cliente acepta pagar todos los montos y las
    cantidades adeudadas en el momento en que <strong>A3</strong> lo solicite.
</p>
<p>
    5.14. Cualquier servicio adicional que solicite el Cliente distinto de
    aquellos contemplados en el Plan originalmente contratado, por ejemplo, la
    validación de constancias de conservación de mensajes de datos, deberán
    contratarse y pagarse en la forma y en el monto acordado en el momento de
    su contratación.
</p>
<p>
    5.15. <strong>A3</strong> se reserva el derecho a modificar, terminar o
    corregir los costos y características asociadas a los Planes. Antes de
    cambiar los costos vigentes se notificará al Cliente con al menos treinta
días de anticipación. En todo caso la utilización continua de    <strong>govo.legal</strong>, después de que se hayan realizado
    los cambios, constituirá la aceptación de dichos cambios.
</p>
<p>
    <strong>6. </strong>
    <strong>OBLIGACIONES PARA LOS USUARIOS</strong>
</p>
<p>
    6.1. El Usuario es el único responsable de determinar la idoneidad de los
    servicios que se prestan a través de <strong>govo.legal</strong>
    , así como de cumplir con todas las disposiciones legales aplicables a los
datos, información, documentos que proporciona y al uso que haga de    <strong>govo.legal</strong>.
</p>
<p>
    6.2. El Usuario es el único y exclusivo responsable del uso y seguridad de
su correo electrónico y contraseña como mecanismo de autenticación en    <strong>govo.legal</strong>, así como de su cuenta y de la
información y documentación que proporcione a través de    <strong>govo.legal</strong>. En su caso, es el único responsable
    de proteger y mantener en secreto su Clave privada, Certificado digital y
    contraseña para la creación de la Firma electrónica avanzada o fiable.
</p>
<p>
    6.3. El Usuario es absolutamente responsable de las actividades que se
    realicen en su cuenta y cualquier otra actividad realizada en la misma. Por
    lo que acepta en notificar de cualquier uso no autorizado de su cuenta o
    bien de cualquier situación mediante la cual pudo estar comprometida la
    seguridad de su cuenta.
</p>
<p>
    6.4. <strong>A3 </strong>no será responsable de cualquier daño o perjuicio
    que surja con motivo de un uso no autorizado del correo electrónico y
    contraseña del Usuario, independientemente de si dicho uso es con o sin
    conocimiento del Usuario.
</p>
<p>
    6.5. <strong>A3</strong> acepta que los Usuarios son quienes identifican en
    todo momento cuáles son sus necesidades específicas, incluidas aquellas de
    carácter normativo que establezcan ciertas formalidades para determinados
    actos jurídicos, por lo que <strong>A3</strong> no interviene, de ninguna
    manera, en la selección del tipo de firma que se utilice para firmar
    Documentos electrónicos a través de <strong>govo.legal.</strong>
</p>
<p>
    6.6. El Usuario acepta que en ninguna circunstancia transmitirá ningún tipo
    de contenido que:
</p>
<p>
    a) Sea ilegal o promueve actividades ilegales;
</p>
<p>
    b) Viole cualquier derecho de terceros, incluidos, entre otros, el derecho
    a la privacidad, el derecho a la propia imagen, el derecho de autor,
    derechos de marca, patentes, secretos comerciales o industriales, o
    cualquier otra propiedad;
</p>
<p>
    c) Sea dañino, difame, abuse, amenace o incite a la violencia frente a un
    individuo o un grupo de personas;
</p>
<p>
    d) Sea pornográfico o sexualmente explícito, discriminatorio, vulgar,
    obsceno, calumnioso, incite al odio o violencia, o de cualquier otro modo
    victimiza o discrimina a un grupo por razón de religión, sexo, orientación
    sexual, raza, edad, entre otros;
</p>
<p>
    e) Sea un spam, robots, consista en propaganda no autorizada, y
</p>
<p>
    f) Contenga virus, o cualquier tipo de sistema que tenga la intención de
    dañar, destruir o limitar las funciones de hardware, software, o equipo de
    telecomunicaciones o que permita el acceso a datos o información no
    autorizada de una tercera parte.
</p>
<p>
    6.7. El Usuario no deberá, ni permitirá que otros lleven a cabo, las
    siguientes actividades relacionadas con los servicios que se prestan en el
    sitio web
    <a href="http://www.govo.legal/" target="_blank">
        <strong>www.govo.legal</strong>
    </a>
    ni en <strong>govo.legal</strong>:
</p>
<p>
    a) Usarlos para fines ilícitos, en contra de las buenas costumbres o que
    afecten el orden público;
</p>
<p>
    b) Vender, revender, alquilar, arrendar, transferir o compartir los
    servicios contratados, así como la información y documentación técnica y
    funcional de <strong>govo.legal</strong> que se le proporcione;
</p>
<p>
    c) Ingresar al sitio web
    <a href="http://www.govo.legal/" target="_blank">
        <strong>www.govo.legal</strong>
    </a>
    o utilice <strong>govo.legal </strong>con el fin de desarrollar
u operar productos o servicios como competencia de los servicios que ofrece<strong>A3</strong> o permita el acceso a un competidor directo de    <strong>A3</strong>;
</p>
<p>
    d) Distribuir virus informáticos u otros códigos, archivos o programas que
    interrumpan, destruyan o limiten la funcionalidad de cualquier software o
    hardware o equipo de comunicaciones electrónicas;
</p>
<p>
    e) Interferir, interrumpir, deshabilitar, sobrecargar o destruir la
    funcionalidad o el uso de cualquier característica al sitio web
    <a href="http://www.govo.legal/" target="_blank">
        <strong>www.govo.legal</strong>
    </a>
    , o los servidores o redes conectadas al sitio web
    <a href="http://www.govo.legal/" target="_blank">
        <strong>www.govo.legal</strong>
    </a>
    o cualquiera de los servicios de <strong>govo.legal</strong>;
</p>
<p>
    f) "Hackear" o acceder sin permiso a los registros privados o
    confidenciales de otro Usuario, o los de cualquier otra persona;
</p>
<p>
    g) Descompilar, haga ingeniería inversa, desensamblar o intentar obtener el
    código fuente del sitio web
    <a href="http://www.govo.legal/" target="_blank">
        <strong>www.govo.legal</strong>
    </a>
    <strong> </strong>
    y/o de<strong> govo.legal</strong>;
</p>
<p>
    h) Eliminar, eludir, inhabilitar, dañar o interferir de cualquier otro modo
    las características relacionadas con la seguridad al sitio web
    <a href="http://www.govo.legal/" target="_blank">
        <strong>www.govo.legal</strong>
    </a>
    <strong> </strong>
    y/o en<strong> govo.legal</strong>; o
</p>
<p>
    i) Utilizar medios automáticos o manuales para violar las restricciones en
    los encabezados de exclusión de robots en el sitio web
    <a href="http://www.govo.legal/" target="_blank">
        <strong>www.govo.legal</strong>
    </a>
    <strong> </strong>
    y/o en<strong> govo.legal</strong>, o evitar o eludir otras
    medidas empleadas para prevenir o limitar el acceso, por ejemplo, al
    participar en prácticas como “screen scraping”, “database scraping,” o
    cualquier otra actividad, con el propósito de obtener listas de Usuarios u
    otra información.
</p>
<p>
    6.8. El Usuario utiliza<strong> govo.legal</strong> para
    ejecutar los procesos de firmado electrónico que haya acordado y conforme
al tipo de firma que haya elegido para hacerlo, por lo que entiende que<strong>A3 </strong>y<strong> </strong><strong>govo.legal </strong>no intervienen en dicha decisión ni    <strong> </strong>recomiendan ningún tipo de firma.
</p>
<p>
    6.9. El Usuario se obliga a sacar en paz y a salvo a <strong>A3</strong>, a
    sus accionistas, subsidiarias, afiliadas, funcionarios, directores,
    empleados, asesores, apoderados, representantes y/o cualquier persona
    relacionada con esta, respecto del uso de la información o documentación de
    otro Usuario a través del sitio
    <a href="http://www.govo.legal/" target="_blank">
        <strong>www.govo.legal</strong>
    </a>
    , en la inteligencia de que <strong>A3</strong> no es, ni será responsable
    de cualquier uso que el Usuario le dé a dicha información o documentación,
    ni por las consecuencias generadas o que pudieran generarse derivado de su
    uso.
</p>
<p>
    6.10. Al utilizar <strong>govo.legal</strong>, el Usuario acepta
defender, indemnizar y mantener libre de cualquier reclamación a    <strong>A3</strong> respecto a dicho uso, al igual que a los accionistas,
    funcionarios, directores, empleados, agentes, sucesores y cesionarios y
    compañías controladas, controladas y afiliadas, respecto de todas y cada
    una de las reclamaciones, demandas, pérdidas, daños, o gastos relacionados
    con, o que resulten de sus operaciones comerciales.
</p>
<p>
    6.11. El Usuario puede enviar, publicar, cargar o poner a disposición de
    otro Usuario contenido como Mensajes de Datos y/o Documentos electrónicos,
    por lo que declara y garantiza que:
</p>
<p>
    a) Posee todos los derechos sobre el contenido de dichos documentos;
</p>
<p>
    b) El contenido es veraz y exacto; y
</p>
<p>
    c) No infringe estos Términos y Condiciones ni ninguna ley aplicable.
</p>
<p>
    6.12. El Usuario reconoce y acepta que <strong>A3</strong> no verifica,
    adopta, ratifica, ni aprueba el contenido que el Usuario envíe, publique,
    cargue o ponga a disposición de otro Usuario, por lo que acepta que debe
    evaluar y asumir todos los riesgos asociados con su contenido, así como su
    precisión, integridad, legitimidad o utilidad de este.
</p>
<p>
    <strong>7. </strong>
    <strong>RESTRICCIONES AL SERVICIO</strong>
</p>
<p>
    7.1. <strong>A3 </strong>no es un despacho jurídico, no ofrece
    representación legal, no ofrece consejo legal, ni emite opiniones,
    recomendaciones, referencias o consultoría relacionada con las actividades
    que se ejecutan en el sitio
    <a href="http://www.govo.legal/" target="_blank">
        <strong>www.govo.legal</strong>
    </a>
, ni con los servicios que se prestan en    <strong>govo.legal. </strong>Por lo anterior el Usuario excluye
    a <strong>A3</strong> tanto de los derechos como de las obligaciones que
emanen de los actos jurídicos que sean firmados mediante    <strong>govo.legal.</strong>
</p>
<p>
    7.2. <strong>A3</strong> no es un Prestador de Servicios de Certificación
conforme al marco legal nacional. No obstante,    <strong>govo.legal</strong> cuenta con la integración de
    servicios proporcionados por Prestadores de Servicios de Certificación
    debidamente acreditados por la Secretaría de Economía.
</p>
<p>
    7.3. <strong>A3</strong> facilita a los Usuarios un mecanismo de firmado
    electrónico a través de <strong>govo.legal</strong> conforme a
    lo dispuesto en el Título Segundo De Comercio Electrónico del Código de
    Comercio, por lo que no representa a ninguno de ellos ni prejuzga sobre la
    autenticidad, contenido, legalidad y veracidad de la información que obre
    en los Documentos electrónicos que recíprocamente se envíen y reciban los
    Usuarios.
</p>
<p>
    7.4. <strong>A3 </strong>no garantiza las acciones u omisiones de los
    Usuarios que usen <strong>govo.legal</strong> o el sitio
    <a href="http://www.govo.legal/" target="_blank">
        <strong>www.govo.legal</strong>
    </a>
    .
</p>
<p>
    7.5. <strong>A3</strong> no garantiza la idoneidad, funcionalidad,
    disponibilidad, permanencia y continuidad de la operación del sitio web
    <a href="http://www.govo.legal/" target="_blank">
        <strong>www.govo.legal</strong>
    </a>
    así como de <strong>govo.legal</strong>, por lo que el Usuario
    lo libera de cualquier responsabilidad por cualquier daño o perjuicio de
    cualquier naturaleza que pueda surgir con motivo de lo anterior.
</p>
<p>
    7.6. <strong>A3</strong> no garantiza la idoneidad, funcionalidad,
    disponibilidad, permanencia y continuidad de la operación del sitio web
    <a href="http://www.govo.legal/" target="_blank">
        <strong>www.govo.legal</strong>
    </a>
    así como de <strong>govo.legal</strong>, por lo que se refiere a
    servicios que dependen de terceros, tales como aquellos que permitan la
    verificación y validación de certificados digitales emitidos por
    Autoridades Certificadoras o bien servicios proporcionados por Prestadores
    de Servicios de Certificación, así como proveedores de infraestructura,
    entre otros servicios.
</p>
<p>
    7.7. <strong>A3</strong> no se hace responsable de los daños y perjuicios
    ocasionados, incluidos aquellos que se presenten en el equipo de cómputo o
    teléfonos móviles de los Usuarios, como consecuencia de cualquier violación
    de seguridad, virus, errores, alteraciones intervenciones no autorizadas,
    fraudes, errores, omisiones, interrupciones, eliminaciones, defectos,
    demoras en el funcionamiento o la transmisión, fallos en la línea del
    equipo o cualquier otro fallo técnico o de otro tipo.
</p>
<p>
    7.8. El Usuario debe considerar también que el envío de correos
    electrónicos a través del internet puede ser un medio no seguro, y debe
considerar esto antes de usar los servicios que se prestan en    <strong>govo.legal</strong>.
</p>
<p>
    7.9. <strong>A3</strong> no será responsable en los siguientes casos:
</p>
<p>
    a) Por cualquier tipo de daños y/o perjuicios que sufran los Usuarios
derivados del uso indebido de los servicios que se prestan en    <strong>govo.legal</strong>;
</p>
<p>
    b) Frente a terceros afectados;
</p>
<p>
    c) En su caso, cuando el o los Certificados digitales no se encuentren
    vigentes, sean revocados o no sean autenticos, y
</p>
<p>
    d) Retrasos y afectaciones derivados por servicios contratados a terceros.
</p>
<p>
    <strong>8. </strong>
    <strong>PROPIEDAD INTELECTUAL</strong>
</p>
<p>
    8.1. <strong>govo.legal</strong>, así como el sitio web
    <a href="http://www.govo.legal/" target="_blank">
        <strong>www.govo.legal</strong>
    </a>
    está protegido de acuerdo con la Ley Federal del Derecho de Autor, Ley
    Federal de Protección a la Propiedad Industrial y demás disposiciones
    legales aplicables, por lo que el Visitante o el Usuario acepta cumplir con
    dichas disposiciones.
</p>
<p>
8.2. El Visitante o el Usuario reconocen que    <strong>govo.legal</strong> es una obra original que han sido
desarrollada, compilada, preparada, revisada, seleccionada y organizada por    <strong>A3</strong> a través de la aplicación de métodos y estándares,
    mediante la inversión sustancial de tiempo, esfuerzo y dinero, y por lo
cual constituye propiedad intelectual valiosa que pertenece a    <strong>A3</strong>.
</p>
<p>
    8.3. Todos los derechos presentes y futuros en materia de propiedad
    industrial y de autor tales como secretos comerciales, patentes, diseños,
    derechos de autor, marcas, logotipos, dibujos, know how, obras,
    conocimientos técnicos, mejoras, contribuciones de diseño u obras
    derivados, así como cualquier conocimiento o proceso relacionado con los
    mismos, incluidos los derechos en y para todas las aplicaciones y software
    relacionados con <strong>govo.legal</strong> así como el sitio
    web
    <a href="http://www.govo.legal/" target="_blank">
        <strong>www.govo.legal</strong>
    </a>
    , serán, en todo momento propiedad única y exclusiva de <strong>A3</strong>
. Y aquellos de otro tipo que se encuentren o relacionen con    <strong>govo.legal </strong>cuentan con todos los permisos y
    autorizaciones necesarios para su uso, comercialización y explotación.
</p>
<p>
    8.4. El Visitante o el Usuario se obligan a no explotar, comercializar,
    copiar, adquirir o de cualquier otra forma hacer uso de la propiedad
    intelectual de <strong>A3</strong>, ni ostentarse como propietario,
    licenciatario, concesionario, permisionario y/o como cualquier clase de
    entidad o individuo con licencia, concesión, permiso, capacidad, facultad,
    derecho o autorización para hacer uso de esta.
</p>
<p>
    8.5. Las marcas, logotipos, eslóganes o avisos comerciales que se muestran
    en el sitio web
    <a href="http://www.govo.legal/" target="_blank">
        <strong>www.govo.legal</strong>
    </a>
    <strong> </strong>
    son propiedad de <strong>A3</strong>, por lo que no debe utilizarlas en
    ningún tipo de campaña o publicidad, ni para indicar el patrocinio o la
    contratación de <strong>govo.legal</strong> con ningún producto,
    servicio, evento u organización, sin la autorización previa y por escrito
    de <strong>A3</strong>.
</p>
<p>
    8.6. <strong>A3</strong> reconoce que pudiera mencionar en el sitio web
    <a href="http://www.govo.legal/" target="_blank">
        <strong>www.govo.legal</strong>
    </a>
    <strong> </strong>
    otras marcas de otras organizaciones para productos o servicios contratados
    con terceros.
</p>
<p>
    8.7. El Visitante o el Usuario no adquiere ni podrá adquirir derecho alguno
de propiedad intelectual por el hecho de hacer uso de servicios de    <strong>govo.legal</strong> ni del sitio web
    <a href="http://www.govo.legal/" target="_blank">
        <strong>www.govo.legal</strong>
    </a>
    <strong> </strong>
    y en ningún momento dicho uso será considerado como una autorización ni
    licencia para utilizarlos con fines distintos a los establecidos en los
    presentes Términos y Condiciones.
</p>
<p>
    <strong>9. </strong>
    <strong>CONFIDENCIALIDAD</strong>
</p>
<p>
    9.1. Se entiende por Información Confidencial":
</p>
<p>
    a) Para <strong>A3</strong>, los<strong> </strong>servicios que se prestan
    a través de <strong>govo.legal</strong> y el sitio web
    <a href="http://www.govo.legal/" target="_blank">
        <strong>www.govo.legal</strong>
    </a>
    ;<strong></strong>
</p>
<p>
b) Para el Usuario, la información proporcionada por éstos, y    <strong> </strong>
</p>
<p>
    c) Cualquier otra información de una de las partes que sea divulgada de
    manera escrita o verbal y que sea designada como confidencial en el tiempo
    en que dicha información fue divulgada, o que, debido a la naturaleza de la
    información, el Receptor debiera claramente entender que dicha información
    divulgada por la parte es información confidencial de dicha parte.
</p>
<p>
    9.2. La Información Confidencial no deberá incluir ninguna información que:
</p>
<p>
    a) Haya sido o llegue a ser de conocimiento público, sin que el receptor
    tenga la culpa de esto o sea como resultado de incumplimiento de estos
    Términos y Condiciones;
</p>
<p>
    b) Estaba legítimamente en posesión del Receptor en el momento de dicha
    divulgación, sin restricción alguna de uso o divulgación;
</p>
<p>
    c) Fue desarrollada independientemente por el Receptor sin la utilización
    de la Información Confidencial de la parte divulgadora; o
</p>
<p>
    d) Fue obtenida legítimamente por el Receptor por medio de un tercero que
    no tenía obligación de confidencialidad y sin restricciones de uso o
    divulgación.
</p>
<p>
    9.3. Durante y después del periodo de contratación del Plan, la parte
    receptora de la Información Confidencial deberá:
</p>
<p>
    a) Utilizar la Información Confidencial de la otra parte solo para los
propósitos para los cuales se proporcionó dicha información;    <strong></strong>
</p>
<p>
    b) No divulgará dicha Información Confidencial a un tercero, y en caso de
    ser necesario únicamente será para aquellos con quienes estén bajo
    obligaciones de confidencialidad al menos tan restrictivas como las que se
    incluyen en estos Términos y Condiciones, y <strong></strong>
</p>
<p>
    c) Proteger dicha Información Confidencial del uso y divulgación no
    autorizado en la misma medida que protege su propia Información
    Confidencial o de naturaleza similar.
</p>
<p>
9.4. Sin perjuicio de lo anterior, el Usuario autoriza expresamente a    <strong>A3</strong> a tratar sus datos conforme a los alcances establecidos
en el Aviso de Privacidad que se encuentra disponible en el sitio web    <strong> </strong>
    <a href="http://www.govo.legal/" target="_blank">
        <strong>www.govo.legal</strong>
    </a>
. Lo anterior en el entendido que toda la Información Confidencial que    <strong>A3</strong> recibe del Usuario por cualquier medio, es propiedad
    exclusiva del Usuario. Por lo que <strong>A3</strong> no detenta ningún
    derecho, título o interés sobre dicha Información Confidencial.
</p>
<p>
    9.5. <strong>A3</strong> se obliga a tomar las providencias necesarias para
    que las personas que en su caso tengan acceso a la Información Confidencial
con motivo o como consecuencia de los servicios prestados a través de    <strong>govo.legal</strong>, no la divulguen y que terceras
    personas ajenas a las partes, no tengan acceso a ella.
</p>
<p>
9.6. Se informa que, si por disposición legal se exige que    <strong>A3</strong> revele Información Confidencial, <strong>A3</strong>
    dará aviso al Usuario antes de hacer la divulgación, salvo que por
    disposición legal dicha notificación esté prohibida.
</p>
<p>
    <strong>10. </strong>
    <strong>R</strong>
    <strong>
        ESPONSABILIDADES DERIVADAS DE LA FALTA DE DISPONIBILIDAD, ACCESIBILIDAD
        O INTERRUPCIÓN EN EL FUNCIONAMIENTO DE
    </strong>
    <strong>govo.legal</strong>
    <strong>.</strong>
</p>
<p>
10.1. <strong>A3</strong> ofrece la disponibilidad de    <strong>govo.legal</strong> en la forma y condiciones en que se
    encuentra publicada en internet, sin garantía de ningún otro servicio no
    especificado en los presentes Términos y Condiciones.
</p>
<p>
    10.2. <strong>A3</strong> se encuentra sujeto a los niveles de servicio que
    tenga contratados con los proveedores de telecomunicaciones e
infraestructura para asegurar la disponibilidad y accesibilidad de    <strong>govo.legal</strong>, por lo que no garantiza que en todo
    momento se encuentre el servicio disponible y sin interrupciones, o que se
    encuentre 100% libre de sistemas maliciosos, defectos, o errores.
</p>
<p>
    10.3. <strong>A3</strong> únicamente se hace responsable de los aspectos
técnicos funcionales de <strong>govo.legal</strong>,    <strong> </strong>salvo por aquellos que sean provistos por terceros
    externos tales como servicios de infraestructura, verificación de vigencia
    de Certificados digitales y aquellos proporcionados por Prestadores de
    Servicios de Certificación.
</p>
<p>
    10.4. <strong>A3</strong> llevará a cabo tareas correctivas, de
    mantenimiento o actualización a fin de mantener el correcto funcionamiento
    de <strong>govo.legal</strong>.
</p>
<p>
    10.5. <strong>A3</strong> empleará las medidas técnicas de seguridad que
    sean comercialmente razonables, mismas que están diseñadas para evitar el
    acceso, uso, alteración o divulgación ilícita o no autorizada de los datos
    personales de los Usuarios.
</p>
<p>
    <strong>11. </strong>
    <strong>DERECHOS AL CONSUMIDOR</strong>
</p>
<p>
    11.1. <strong>A3</strong> le informa que conforme a las disposiciones
    contenidas en la Ley Federal de Protección al Consumidor los derechos del
    consumidor de nuestros Clientes se encuentran protegidos.
</p>
<p>
    11.2. El Cliente podrá revocar su consentimiento sobre la prestación de los
    servicios sin responsabilidad, ni justificación alguna, siempre y cuando lo
    realice dentro de los cinco días hábiles contados a partir de la aceptación
    del servicio, no haya utilizado los servicios contratados y no se haya
    materializado el pago de la prestación del servicio.
</p>
<p>
    <strong>12. </strong>
    <strong>MECANISMOS DE NOTIFICACIONES O MEDIOS DE COMUNICACIÓN EN </strong>
    <strong>govo.legal</strong>
    <strong>.</strong>
</p>
<p>
    12.1. El Usuario acepta recibir cualquier comunicación, notificación y/o
    aviso sobre los servicios prestados por medios electrónicos, incluyendo
mensajes de texto, notificaciones a través de    <strong>govo.legal</strong>, publicaciones en el sitio o a
    través del correo electrónico que haya señalado al momento del registro de
    su cuenta, y por esta razón se obliga a mantener actualizada la información
    de contacto en su cuenta.
</p>
<p>
    12.2. Adicionalmente<strong> govo.legal</strong> cuenta con un
    mecanismo de comunicación a través de la cuenta de correo electrónico
    <a href="mailto:contacto@govo.legal">
        contacto@govo.legal
    </a>
para cualquier asunto relacionado con    <strong>govo.legal</strong>.
</p>
<p>
    12.3. El Usuario manifiesta su consentimiento para recibir notificaciones
    conforme a lo establecido en los presentes Términos y Condiciones y por lo
    tanto dichas notificaciones tienen pleno efecto legal, incluso si la
    información de contacto proporcionada al momento de su registro se
    encuentra desactualizada, saturada, incorrecta, bloqueada o sujeta a
    filtros de su administrador de cuentas.
</p>
<p>
    <strong>13. </strong>
    <strong>
        MECANISMOS DE SOLUCIÓN PARA LAS RECLAMACIONES O ACLARACIONES
    </strong>
</p>
<p>
    13.1. En caso de que el Usuario crea de buena fe que el servicio recibido
    no se apega a lo establecido en los presentes Términos y Condiciones, o
    bien el costo reflejado en su factura no es acorde con el costo acordado,
    podrá solicitar a <strong>A3</strong> el inicio del servicio de aclaración
o reclamación, para llegar a un acuerdo con <strong>A3</strong>, y    <strong> </strong>para ello deberá:
</p>
<p>
    a) Enviar correo electrónico a la cuenta
    <a href="mailto:contacto@govo.legal">
        contacto@govo.legal
    </a>
    con el detalle de los hechos y circunstancias sobre la cual basa su
    solicitud de aclaración o reclamación. En este caso, <strong>A3 </strong>
    intentará de buena fe alcanzar un acuerdo con el Usuario en un plazo no
    mayor a 15 días naturales. De alcanzar el acuerdo ambas partes considerarán
    como definitiva la solución acordada.
</p>
<p>
    b) En caso de no alcanzar acuerdo, quedarán a salvo los derechos del
    Usuario para utilizar cualquier otro medio legal que le asista.
</p>
<p>
    13.2. Adicionalmente al procedimiento anteriormente descrito, se informa
    que, conforme a lo dispuesto en la Ley Federal de Protección al Consumidor,
    la Procuraduría Federal de Protección al Consumidor es la autoridad
    facultada para recibir quejas o reclamaciones de los Usuario de manera
    individual o grupal con base en dicha ley.
</p>
<p>
    <strong>14. </strong>
    <strong>CONTENIDO Y PUBLICIDAD</strong>
</p>
<p>
14.1. En caso de que exista contenido en    <strong>govo.legal</strong> de terceras partes, como, por
    ejemplo, artículos, referencias a otros sitios de internet, blogs, entre
    otros, estos únicamente se dan a conocer como cortesía y servicio de valor
    agregado para con el Usuario, por lo tanto, <strong>A3</strong> no se hace
    responsable por dicho contenido.
</p>
<p>
14.2. Salvo por el contenido directamente desarrollado por    <strong>A3</strong>, cualquier otro contenido originado, transmitido,
    almacenado o procesado en <strong>govo.legal</strong> no se
    reputa de su autoría.
</p>
<p>
    <strong>15. </strong>
    <strong>MODIFICACIONES DE LOS TÉRMINOS Y CONDICIONES</strong>
</p>
<p>
    15.1. <strong>A3</strong> puede modificar los presentes Términos y
    Condiciones sobre cuestiones relevantes para la prestación de los servicios
    de <strong>govo.legal</strong> ofrecidos en el sitio web
    <a href="http://www.govo.legal/" target="_blank">
        <strong>www.govo.legal</strong>
    </a>
    <strong>, </strong>
    particularmente para reflejar algún cambio en la normativa que resulte
    aplicable o bien para mejorar la experiencia de los Usuarios.
</p>
<p>
    15.2. En este caso, se publicarán los nuevos términos en el sitio antes
    mencionado con la referencia sobre la última actualización y su entrada en
    vigor. Se recomienda al Usuario revisar de manera regular el sitio para
    contar oportunamente con la notificación sobre las modificaciones, en el
entendido que si usted sigue utilizando    <strong>govo.legal</strong> y el sitio
    <a href="http://www.govo.legal/" target="_blank">
        <strong>www.govo.legal</strong>
    </a>
    así como disfrutando de los servicios que se prestan a través de dicho
    sitio después de la entrada en vigor de las modificaciones notificadas,
    acepta los Términos y Condiciones bajo los alcances en que se hayan
    publicado.
</p>
<p>
    15.3. Si no está de acuerdo con el contenido de las modificaciones a los
Términos y Condiciones no estará autorizado para usar    <strong>govo.legal</strong> ni el sitio
    <a href="http://www.govo.legal/" target="_blank">
        <strong>www.govo.legal</strong>
    </a>
    por lo que deberá abstenerse de registrarse y dejar de utilizar el sitio
    mencionado, así como cualquier servicio que se preste a través de este.
</p>
<p>
    <strong>16. </strong>
    <strong>TERMINACIÓN Y CONCLUSIÓN DEL USO DE </strong>
    <strong>govo.legal</strong>
</p>
<p>
16.1. En cualquier momento el Usuario puede cancelar su cuenta en    <strong>govo.legal</strong>. Lo anterior, no implica la
    terminación de la relación contractual con el Cliente y sus obligaciones.
</p>
<p>
    16.2. Para tal caso, el Usuario podrá dejar de usar su cuenta o bien enviar
    un correo electrónico a
    <a href="mailto:contacto@govo.legal">
        contacto@govo.legal
    </a>
    solicitando su cancelación.
</p>
<p>
    16.3. Si el Cliente cancela su Plan, <strong>A3</strong> no se encontrará
    obligado a reembolsar los montos pagados.
</p>
<p>
    16.4. Cada Plan contratado por el Cliente, incluye restricciones y
requisitos sobre los servicios que se prestan a través de    <strong>govo.legal</strong> cualquier violación a dichos
    alcances puede resultar en la terminación inmediata de su derecho a
    utilizar <strong>govo.legal</strong>, sin perjuicio de la
    responsabilidad que derive por los daños y perjuicios por infracciones de
    cualquier otra naturaleza.
</p>
<p>
16.5. El Usuario reconoce y acepta que    <strong>govo.legal</strong> pudiera llevar a cabo el monitoreo
    del uso de la plataforma para identificar interacciones en contra de lo
    establecido en los presentes Términos y Condiciones, por lo que tiene el
    derecho, a discreción, de determinar la terminación del uso de la
    plataforma con motivo de un uso no adecuado, sin que medie previo aviso.
</p>
<p>
    <strong>17. </strong>
    <strong>DISPOSICIONES LEGALES APLICABLES</strong>
</p>
<p>
    17.1. Para la interpretación, cumplimiento y ejecución de los presentes
    Términos y Condiciones, las partes acuerdan que serán aplicables las leyes
    vigentes de los Estados Unidos Mexicanos y serán competentes los tribunales
    del estado de Nuevo León.
</p>
<p>
    17.2. De manera particular los presentes Términos y Condiciones se
    encuentran regulados por las disposiciones contenidas en el Código de
    Comercio, la Ley Federal de Protección al Consumidor, Ley Federal de
    Protección de Datos Personales en Posesión de los Particulares en lo que
    resulte aplicable.
</p>
</div>
</div>
</body>
</html>
`;